import React, { FC } from "react";
import { ApplicationsInvitations } from "../../../../common/enums/common.enums";
import "./InvitationsTab.scss";
const InvitationsTab: FC<{
  isActive: boolean;
  title: string;
  step: ApplicationsInvitations;
  amount: string | undefined;
  handleClick: (step: ApplicationsInvitations) => void;
}> = ({ handleClick, isActive, title, step, amount }) => {
  return (
    <button
      onClick={() => handleClick(step)}
      className={`${
        isActive ? "invitations-tab invitations-tab--active" : "invitations-tab"
      }`}
    >
      {title} ({amount})
    </button>
  );
};

export default InvitationsTab;
